import React from 'react';
import ReactDOM from 'react-dom/client';

import { ErrorBoundary } from '@aia/ui-components';

import App from './App';
import './styles/globals.css';
import { initFrontendTelemetry } from './lib/telemetry';

initFrontendTelemetry();

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
